// extracted by mini-css-extract-plugin
module.exports = {"quoteP":"component-module--quote-p--1auxJ","container":"component-module--container--2rmI6","item":"component-module--item--3SPBF","withImg":"component-module--with-img--2KGZQ"};